/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rte_Upload_UnsupportedInputs */



/**
* | output |
* | --- |
* | "File type not supported" |
*
* @param {Rte_Upload_UnsupportedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const rte_upload_unsupported = /** @type {((inputs?: Rte_Upload_UnsupportedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rte_Upload_UnsupportedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Dit bestandstype kan hier niet")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce type de fichier n'est pas pris en charge")
	return /** @type {LocalizedString} */ ("File type not supported")
});